import ProfileIcon from "../../../../assets/images/member/user-icon.svg";
import {ChangeEvent, useEffect, useRef} from "react";
import CameraIcon from "../../../../assets/images/member/camera.svg";
import NonProfile from "../../../../assets/images/member/non-profile.svg";
import * as API_URL from "../../../../constants/ApiUrl";

export default function UserInfo(props: any) {
    const imageElement = useRef(null);

    useEffect(() => {
        if (props.user.thumbnail !== "") {
            (imageElement.current as any as HTMLImageElement).src = API_URL.IMAGE_SERVER + props.user.thumbnail;
        }
    }, [props.user.thumbnail]);

    const changeName = (event: ChangeEvent<HTMLInputElement>) => {
        props.onChangeName("name", event.target.value);
    }

    const changeThumbnail = (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files!![0].type.includes("image")) {
            alert("이미지 파일만 업로드 가능합니다.");
            return;
        }

        const file = event.target.files!![0];
        (imageElement.current as any as HTMLImageElement).src = URL.createObjectURL(file)

        props.onChangeThumbnailFile(file);
    }

    const changeBasicThumbnail = () => {
        props.onChangeThumbnailFile();
        (imageElement.current as any as HTMLImageElement).src = NonProfile;
    }

    return (
        <div className="member-detail-box">
            <div className="thumbnail-wrapper">
                <div>
                    프로필 사진
                </div>
                <div className="box-wrapper">
                    <label className="photo">
                        <img src={NonProfile} ref={imageElement} alt="userThumbnail"/>
                        <div className="camera-svg">
                            <img src={CameraIcon} alt="camera"/>
                        </div>
                        <input
                            onChange={changeThumbnail}
                            accept="image/*"
                            type="file"
                        />
                    </label>
                    <button className="basic-image" onClick={changeBasicThumbnail}>
                        기본 이미지로 변경
                    </button>
                </div>
            </div>
            <div className="profile-wrapper">
                <div className="box-title">
                    <img src={ProfileIcon} alt="icon"/>
                    <div className="text">
                        프로필정보
                    </div>
                </div>
                <div className="box-information">
                    <div className="title">
                        이름
                    </div>
                    <input
                        type="text"
                        onChange={changeName}
                        defaultValue={props.user.name}
                        className="name"
                    />
                </div>
                <div className="box-information">
                    <div className="title">
                        이메일
                    </div>
                    <div className="email">
                        {props.user.email}
                    </div>
                </div>
            </div>
        </div>
    );
}